import SearchFilter from '../../components/analytics-and-insights/SearchFilter';
import DeletedAccountList from '../../components/deleted-accounts/DeletedAccountList';
const DeletedAccountManagement = () => {

  return (
    <div>
      <div className="d-flex gap-16 align-items-center">
        <span>
          <img
            src="/assets/images/admin-panel/user-management-icon.svg"
            className="img-fluid"
            alt=""
          />
        </span>
        <div className="">
          <div className="d-flex gap-10 text-black align-items-center fw-bold font-p font-36">
            Deleted Accounts
          </div>
          <p>Manage deleted accounts</p>
        </div>
      </div>

    
      <SearchFilter isHideUserManagement={false} />

      <div className="mt-32">
        <DeletedAccountList />
      </div>
    </div>
  );
};

export default DeletedAccountManagement;
